import { render, staticRenderFns } from "./KebabMenuIcon.vue?vue&type=template&id=d2a6a882&scoped=true"
import script from "./KebabMenuIcon.vue?vue&type=script&lang=js"
export * from "./KebabMenuIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a6a882",
  null
  
)

export default component.exports